function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.167 7.167a.5.5 0 01-.5-.5 7.121 7.121 0 00-2.099-5.068.5.5 0 11.707-.708 8.116 8.116 0 012.392 5.776.5.5 0 01-.5.5zM.5 7.167a.5.5 0 01-.5-.5C0 4.485.85 2.434 2.392.892a.5.5 0 01.707.707A7.116 7.116 0 001 6.667a.5.5 0 01-.5.5zM7.333 16a2.503 2.503 0 01-2.5-2.5.5.5 0 011 0c0 .827.673 1.5 1.5 1.5.828 0 1.5-.673 1.5-1.5a.5.5 0 011 0c0 1.379-1.121 2.5-2.5 2.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.833 14h-11a1.168 1.168 0 01-.758-2.053 4.468 4.468 0 001.592-3.422V6.667A4.672 4.672 0 017.333 2 4.672 4.672 0 0112 6.667v1.858c0 1.32.578 2.565 1.585 3.417A1.167 1.167 0 0112.833 14zm-5.5-11a3.67 3.67 0 00-3.666 3.667v1.858a5.464 5.464 0 01-1.94 4.18.166.166 0 00.106.295h11c.09 0 .167-.076.167-.167a.164.164 0 00-.059-.126A5.466 5.466 0 0111 8.525V6.667A3.67 3.67 0 007.333 3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.333 3a.5.5 0 01-.5-.5v-2a.5.5 0 011 0v2a.5.5 0 01-.5.5z"
});

function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3);
}

export default SvgNotification;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/notification.svg
// module id = 1276
// module chunks = 10